export default "__VITE_ASSET__bb69ff13__"